/**
 * Common Queries
 *
 * Frequently used queries for common security exposures and risks.
 * These queries are useful across all customer environments.
 */

import type { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';

import { QueryFolders } from './folders';

export const COMMON_QUERIES: SavedQuery[] = [
  {
    id: 'demonstrated-critical-risks',
    name: 'Demonstrated Critical Risks',
    type: 'table',
    description:
      'Display all critical-severity risks that have been Demonstrated.',
    folderId: QueryFolders.COMMON_QUERIES,
    query: {
      node: {
        labels: ['Risk'],
        filters: [
          {
            field: 'status',
            operator: '=',
            value: 'OC',
          },
        ],
      },
      limit: 1000,
    },
  },
  {
    id: 'demonstrated-critical-high-medium-risks',
    name: 'Demonstrated Critical, High & Medium Risks',
    type: 'table',
    description:
      'Display all critical, high, and medium-severity risks that have been Demonstrated.',
    folderId: QueryFolders.COMMON_QUERIES,
    query: {
      node: {
        labels: ['Risk'],
        filters: [
          {
            field: '',
            operator: 'OR',
            value: [
              {
                field: 'status',
                operator: '=',
                value: 'OC',
              },
              {
                field: 'status',
                operator: '=',
                value: 'OH',
              },
              {
                field: 'status',
                operator: '=',
                value: 'OM',
              },
            ],
          },
        ],
      },
      orderBy: 'priority',
      descending: false,
      limit: 1000,
    },
  },
  {
    id: 'detected-critical-risks',
    name: 'Detected Critical Risks',
    type: 'table',
    description: 'Display all critical-severity risks that have been Detected.',
    folderId: QueryFolders.COMMON_QUERIES,
    query: {
      node: {
        labels: ['Risk'],
        filters: [
          {
            field: 'status',
            operator: '=',
            value: 'TC',
          },
        ],
      },
      limit: 1000,
    },
  },
  {
    id: 'resolved-critical-risks',
    name: 'Resolved Critical Risks',
    type: 'table',
    description: 'Display all critical-severity risks that have been Resolved.',
    folderId: QueryFolders.COMMON_QUERIES,
    query: {
      node: {
        labels: ['Risk'],
        filters: [
          {
            field: 'status',
            operator: '=',
            value: 'RC',
          },
        ],
      },
      limit: 1000,
    },
  },
  {
    id: 'active-assets',
    name: 'Active Assets',
    type: 'table',
    description: 'Display all assets with Active status.',
    folderId: QueryFolders.COMMON_QUERIES,
    query: {
      node: {
        labels: ['Asset'],
        filters: [
          {
            field: '',
            operator: 'OR',
            value: [
              {
                field: 'status',
                operator: '=',
                value: 'A',
              },
              {
                field: 'status',
                operator: '=',
                value: 'AL',
              },
              {
                field: 'status',
                operator: '=',
                value: 'AP',
              },
              {
                field: 'status',
                operator: '=',
                value: 'AH',
              },
            ],
          },
        ],
      },
      limit: 1000,
    },
  },
];
